export const SET_USER_LOGGEDIN = 'setLoggedIn'
export const SET_USER_USERNAME = 'setUsername'
export const SET_USER_PREMIUM = 'setPremium'
export const SET_USER_OLDPREMIUM = 'setOldPremium'
export const SET_USER_EDUCATION= 'setEducation'
export const SET_USER_EDNEEDSUPDATE = 'setEdNeedsUpdate'